import React, { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import "./LeadDetalhes.css";
import { formatarDataBrasil } from "../utils/utils";

export default function LeadDetalhes() {
  const { lead_id } = useParams();
  const navigate = useNavigate();

  const [lead, setLead] = useState(null);
  const [tags, setTags] = useState([]);
  const [tagsDisponiveis, setTagsDisponiveis] = useState([]);
  const [novaTag, setNovaTag] = useState("");
  const [acoes, setAcoes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (lead_id) {
      (async () => {
        await Promise.all([carregarLead(), carregarTagsDisponiveis()]);
        setLoading(false);
      })();
    }
  }, [lead_id]);

  useEffect(() => {
    console.log("Tags do Lead:", tags);
  }, [tags]);

  const carregarLead = async () => {
    try {
      const response = await fetch(
        `https://welaunchyou.com.br/crm-wly/lead_detalhado.php?lead_id=${lead_id}`,
        { credentials: "include" }
      );
      const data = await response.json();

      console.log("Dados recebidos do backend:", data);

      if (data?.lead) {
        setLead(data.lead);
        setAcoes(Array.isArray(data.acoes) ? data.acoes : []);
        setTags(Array.isArray(data.tags) ? data.tags : []);
      } else {
        console.error("Erro: Lead não encontrado");
      }
    } catch (error) {
      console.error("Erro ao carregar lead:", error);
    }
  };

  const carregarTagsDisponiveis = async () => {
    try {
      // Novo contrato do backend: resumo de tags em data.resumo
      const response = await fetch(
        "https://welaunchyou.com.br/crm-wly/tags.php?resumo=1",
        { credentials: "include" }
      );
      const data = await response.json();
      setTagsDisponiveis(Array.isArray(data?.resumo) ? data.resumo : []);
    } catch (error) {
      console.error("Erro ao carregar tags disponíveis:", error);
    }
  };

  const associarTag = async () => {
    if (!novaTag) return;

    try {
      const response = await fetch(
        "https://welaunchyou.com.br/crm-wly/lead_tags.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({ lead_id, tag_id: Number(novaTag) }),
        }
      );

      const data = await response.json();
      if (data?.success) {
        setNovaTag("");
        await carregarLead(); // Recarrega para refletir imediatamente
      } else {
        alert(data?.message || "Erro ao associar tag.");
      }
    } catch (error) {
      console.error("Erro ao associar tag:", error);
    }
  };

  const removerTag = async (tagId) => {
    if (!window.confirm("Remover esta tag do lead?")) return;

    try {
      const response = await fetch(
        "https://welaunchyou.com.br/crm-wly/lead_tags.php",
        {
          method: "DELETE",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({ lead_id, tag_id: Number(tagId) }),
        }
      );

      const data = await response.json();
      if (data?.success) {
        await carregarLead(); // Recarrega para refletir imediatamente
      } else {
        alert(data?.message || "Erro ao remover tag.");
      }
    } catch (error) {
      console.error("Erro ao remover tag:", error);
    }
  };

  const formatarTelefoneVisao = (telefone = "") => {
    if (!telefone.startsWith("55")) return telefone;
    if (telefone.length === 13) {
      // celular com 9
      return telefone.replace(/^55(\d{2})(\d{5})(\d{4})$/, "($1) $2-$3");
    }
    // fixo/sem 9 (10+55=12) ou outros casos
    return telefone.replace(/^55(\d{2})(\d{4})(\d{4})$/, "($1) $2-$3");
  };

if (loading) {
  return (
    <div className="lead-detalhes-root">
      <h1 className="h1-detalhes" style={{ borderBottom: "none" }}>
        Detalhes do Lead
      </h1>

      <div className="lead-detalhes-scroll">
        <div className="lead-detalhes-page">
          <div className="lead-detalhes-container">
            <p className="carregando">Carregando detalhes do lead...</p>
          </div>
        </div>
      </div>
    </div>
  );
}


return (
  <div className="lead-detalhes-root">
    <h1 className="h1-detalhes" style={{ borderBottom: "none" }}>
      Detalhes do Lead
    </h1>

    <div className="lead-detalhes-scroll">
      <div className="lead-detalhes-page">
        <div className="lead-detalhes-container">
          {lead ? (
            <>
              <div className="lead-info-wrapper">
                <div className="lead-info">
                  <p>
                    <strong>Nome:</strong> {lead.nome}
                  </p>
                  <p>
                    <strong>Telefone:</strong>{" "}
                    {formatarTelefoneVisao(lead.telefone)}
                  </p>

                  <Link
                    to={`/wzp/painel-mensagens?telefone=${encodeURIComponent(
                      lead.telefone
                    )}&leadId=${lead.id}`}
                    className="btn-whatsapp"
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      backgroundColor: "#25D366",
                      color: "white",
                      padding: "10px 16px",
                      borderRadius: "6px",
                      marginTop: "10px",
                      textDecoration: "none",
                      fontWeight: "bold",
                    }}
                  >
                    <img
                      src="https://cdn-icons-png.flaticon.com/512/733/733585.png"
                      alt="WhatsApp"
                      style={{ width: "20px", height: "20px", marginRight: "8px" }}
                    />
                    Enviar Mensagem
                  </Link>

                  <p>
                    <strong>Origem do Lead:</strong> {lead.origem_lead}
                  </p>
                  <p>
                    <strong>Interesse:</strong> {lead.interesse}
                  </p>
                  <p>
                    <strong>Data do Primeiro Contato:</strong>{" "}
                    {formatarDataBrasil(lead.data_primeiro_contato)}
                  </p>
                  <p>
                    <strong>Estágio do Funil:</strong> {lead.estagio_funil}
                  </p>
                  <p>
                    <strong>Observação:</strong> {lead.observacao}
                  </p>
                </div>

                <div className="lead-foto-wrapper">
                  <img
                    src={
                      lead.foto ||
                      "https://cdn-icons-png.flaticon.com/512/149/149071.png"
                    }
                    alt="Foto do contato"
                    onError={(e) => {
                      e.currentTarget.src =
                        "https://cdn-icons-png.flaticon.com/512/149/149071.png";
                    }}
                  />
                </div>
              </div>

              {/* TAGS ASSOCIADAS */}
              <h3 className="lead-detalhes-subtitulo">Tags Associadas</h3>
              <ul className="lead-tags-list">
                {tags.length > 0 ? (
                  tags.map((tag) => (
                    <li key={tag.id} className="lead-tag">
                      {tag.nome}
                      <button
                        className="btn-remover-tag"
                        onClick={() => removerTag(tag.id)}
                        title="Remover tag"
                      >
                        ❌
                      </button>
                    </li>
                  ))
                ) : (
                  <p className="nenhuma-tag">
                    Este lead ainda não possui tags.
                  </p>
                )}
              </ul>

              {/* SELECIONAR NOVA TAG */}
              <div className="adicionar-tag-container">
                <select
                  value={novaTag}
                  onChange={(e) => setNovaTag(e.target.value)}
                  className="tag-select"
                >
                  <option value="">Selecione uma Tag</option>
                  {tagsDisponiveis
                    .filter((td) => !tags.some((t) => t.id === td.id))
                    .map((tag) => (
                      <option key={tag.id} value={tag.id}>
                        {tag.nome}
                      </option>
                    ))}
                </select>
                <button
                  className="btn-adicionar-tag"
                  onClick={associarTag}
                  disabled={!novaTag}
                >
                  Adicionar
                </button>
              </div>

              {/* HISTÓRICO DE AÇÕES */}
              <h3 className="lead-detalhes-subtitulo">Histórico de Ações</h3>
              {acoes.length > 0 ? (
                <table className="acoes-table">
                  <thead>
                    <tr>
                      <th>Descrição</th>
                      <th>Data da Ação</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {acoes.map((acao) => (
                      <tr key={acao.id}>
                        <td>{acao.descricao}</td>
                        <td>{formatarDataBrasil(acao.data_acao)}</td>
                        <td>{acao.status}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <p className="nenhuma-tag">
                  Este lead ainda não possui ações registradas.
                </p>
              )}

              <div className="botoes-lead-detalhes">
                <Link to={`/editar-lead/${lead.id}`} className="btn-editar">
                  Editar Lead
                </Link>

                <button
                  className="btn-voltar"
                  onClick={() => {
                    navigate("/listagem-leads", { replace: true });
                    window.location.reload();
                  }}
                >
                  Voltar
                </button>
              </div>
            </>
          ) : (
            <p className="carregando">Lead não encontrado.</p>
          )}
        </div>
      </div>
    </div>
  </div>
);
}
